// ---- ALL IMPORTS MUST BE AT TOP ----
import React, {  useEffect, useState } from "react";
import db from "./firebase";
import { ref, onChildAdded } from "firebase/database";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';
import './App.css';
import './media.css';
import { RenderRout } from './router';
import { PageProvider } from './PageContext';
import SplashScreen from "./components/pages/splash-screen/SplashScreen";


// ---- After imports ----
window.bootstrap = bootstrap;

function App() {
   const [loading, setLoading] = useState(() => {
  return localStorage.getItem("hasSeenSplash") !== "true";
});
  let userId = null;
  try {
    userId = JSON.parse(localStorage.getItem("userData"))?.id;
  } catch (e) {
    userId = null;
  }

  // 🔔 Firebase notifications
  useEffect(() => {
    if (!userId) return;

    const notifRef = ref(db, `notifications/user_${userId}`);
    let initialLoad = true;

    const unsubscribe = onChildAdded(notifRef, (snapshot) => {
      const notification = snapshot.val();

      if (
        !initialLoad &&
        "Notification" in window &&
        Notification.permission === "granted" &&
        notification?.is_read === false
      ) {
        new Notification(notification.title || "New Notification", {
          body: notification.description || "",
          icon: "/image/logo.png",
        });
      }
    });

    setTimeout(() => {
      initialLoad = false;
    }, 1000);

    return () => unsubscribe();
  }, [userId]);

const handleSplashFinish = () => {
  localStorage.setItem("hasSeenSplash", "true");
  setLoading(false);
};


  // 1️⃣ Splash blocks everything
  if (loading) {
    return <SplashScreen onFinish={handleSplashFinish}/>;
  }



  return (
    <div className="App">
      
      <PageProvider>
  <RenderRout />
      </PageProvider>
    
    </div>
  );
}

export default App;
